import { Injectable,Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CkeditorLoaderService {
  ckeConfig: any;

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  ngOnInit() {
    this.ckeConfig = function( config ) {
      config.toolbarGroups = [
        //{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        //{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ];
    
      config.removeButtons = 'Save,Templates,NewPage,ExportPdf,Preview,Print,Source,Cut,Copy,Paste,Undo,Redo,PasteText,PasteFromWord,Find,SelectAll,Replace,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,SpecialChar,Smiley,Iframe,PageBreak,Flash';
    };
  }

  loadCkEditor(){
    if (isPlatformBrowser(this.platformId)) {
      if(window){
        window['CKEDITOR_BASEPATH'] = '//cdn.ckeditor.com/4.6.2/full-all/';
      }
      return true;
    } else if (isPlatformServer(this.platformId)){
        //  server mode detected
    }
  }
}
